<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { DATE_RANGE_OPTIONS } from '../../constants';
import FilterChip from './FilterChip.vue';

const emit = defineEmits(['onRangeChange']);

const { t } = useI18n();

const options = computed(() =>
  Object.values(DATE_RANGE_OPTIONS).map(option => ({
    ...option,
    name: t(option.translationKey),
  }))
);

const selectedId = ref(Object.values(DATE_RANGE_OPTIONS)[0].id);

const selectedOption = computed({
  get() {
    return options.value.find(o => o.id === selectedId.value);
  },
  set(val) {
    selectedId.value = val.id;
  },
});

const updateRange = range => {
  selectedOption.value = range;
  emit('onRangeChange', range);
};
</script>

<template>
  <FilterChip
    :model-value="selectedOption"
    :options="options"
    :prefix="$t('REPORT.FILTER_CHIP.PERIOD')"
    :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
    icon="i-lucide-calendar"
    :clearable="false"
    @update:model-value="updateRange"
  />
</template>
